import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { savePurchaseOperationData } from "../../../apis/apis.logistics/apisProduct";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export function EditOrderPurchaseReceivedList({
    order,
    setOrder,
    initialOrderState,
}) {
    const sendPurchase = async () => {
        try {
            const response = await savePurchaseOperationData(order);
            return response;
        } catch (error) {
            throw error;
        }
    };
    const navigate = useNavigate();

    const handleSave = async () => {
        console.log(order);
        if (order.operationItems.length) {
            if (order.operationDate != "") {
                Swal.fire({
                    title: "¿Está usted seguro?",
                    text: "¿Guardar cambios en esta compra?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#10b981",
                    cancelButtonColor: "#6b7280",
                    confirmButtonText: "Sí, guardar",
                    cancelButtonText: "Cancelar",
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        sendPurchase()
                            .then((r) => {
                                if (r.status == 201) {
                                    toast.success(
                                        "Compra actualizada con éxito!",
                                    );
                                    navigate("/buys/purchase_orders_issued");
                                } else {
                                    toast.error("Ocurrió algún error");
                                }
                            })
                            .then(() => {
                                setOrder(initialOrderState);
                            });
                    }
                });
            } else {
                toast.error("Verifique la fecha");
            }
        }
    };

    const inputClass =
        "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";

    const totalAmount = Number(
        order.operationItems.reduce(
            (previousValue, currentValue) =>
                previousValue +
                Number(currentValue.quantity) * Number(currentValue.price),
            0,
        ),
    ).toFixed(2);

    return (
        <>
            <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm overflow-hidden mb-6">
                {/* Desktop View - Table */}
                <div className="hidden md:block overflow-x-auto">
                    <table className="w-full text-sm text-left">
                        <thead className="bg-gray-900 text-gray-100">
                            <tr>
                                <th className="px-4 py-3 font-semibold text-xs uppercase tracking-wider">
                                    #
                                </th>
                                <th className="px-4 py-3 font-semibold text-xs uppercase tracking-wider">
                                    SKU
                                </th>
                                <th className="px-4 py-3 font-semibold text-xs uppercase tracking-wider">
                                    PRODUCTO
                                </th>
                                <th className="px-4 py-3 font-semibold text-xs uppercase tracking-wider">
                                    UNIDAD
                                </th>
                                <th className="px-4 py-3 font-semibold text-xs uppercase tracking-wider text-right">
                                    PRECIO
                                </th>
                                <th className="px-4 py-3 font-semibold text-xs uppercase tracking-wider text-center">
                                    CANTIDAD ORDENADA
                                </th>
                                <th className="px-4 py-3 font-semibold text-xs uppercase tracking-wider text-right">
                                    SUBTOTAL ORDENADO
                                </th>
                                <th className="px-4 py-3 font-semibold text-xs uppercase tracking-wider text-center">
                                    FEC. VTO
                                </th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                            {order.operationItems.map((item, index) => {
                                const subtotal = (
                                    Number(item.quantity) * Number(item.price)
                                ).toFixed(2);
                                return (
                                    <tr
                                        key={index}
                                        className="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                                    >
                                        <td className="px-4 py-3 text-gray-900 dark:text-white">
                                            {item.operationDetailID}
                                        </td>
                                        <td className="px-4 py-3 text-gray-600 dark:text-gray-400">
                                            {item.sku}
                                        </td>
                                        <td className="px-4 py-3 text-gray-900 dark:text-white">
                                            {item.productName}
                                        </td>
                                        <td className="px-4 py-3 text-gray-600 dark:text-gray-400">
                                            {item.unitName}
                                        </td>
                                        <td className="px-4 py-3 text-gray-900 dark:text-white text-right">
                                            {Number(item.price)}
                                        </td>
                                        <td className="px-4 py-3 text-gray-900 dark:text-white text-center">
                                            {item.quantity}
                                        </td>
                                        <td className="px-4 py-3 text-gray-900 dark:text-white text-right font-semibold">
                                            S/ {subtotal}
                                        </td>
                                        <td className="px-4 py-3">
                                            <input
                                                type="date"
                                                name="expireDate"
                                                className={inputClass}
                                                value={item.expireDate}
                                                onChange={(e) => {
                                                    setOrder({
                                                        ...order,
                                                        operationItems:
                                                            order.operationItems.map(
                                                                (o) => {
                                                                    if (
                                                                        o.operationDetailID ==
                                                                        item.operationDetailID
                                                                    ) {
                                                                        o.expireDate =
                                                                            e.target.value;
                                                                    }
                                                                    return o;
                                                                },
                                                            ),
                                                    });
                                                }}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot className="bg-gray-100 dark:bg-gray-700">
                            <tr>
                                <td
                                    className="px-4 py-3 text-right font-semibold text-gray-900 dark:text-white"
                                    colSpan={6}
                                >
                                    TOTAL
                                </td>
                                <td className="px-4 py-3 text-right font-bold text-gray-900 dark:text-white text-lg">
                                    S/ {totalAmount}
                                </td>
                                <td className="px-4 py-3"></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                {/* Mobile View - Cards */}
                <div className="md:hidden">
                    {order.operationItems.map((item, index) => {
                        const subtotal = (
                            Number(item.quantity) * Number(item.price)
                        ).toFixed(2);
                        return (
                            <div
                                key={index}
                                className="p-4 border-b border-gray-200 dark:border-gray-700 last:border-b-0"
                            >
                                <div className="flex justify-between items-start mb-3">
                                    <div>
                                        <h4 className="font-semibold text-gray-900 dark:text-white">
                                            {item.productName}
                                        </h4>
                                        <p className="text-sm text-gray-600 dark:text-gray-400">
                                            SKU: {item.sku} • {item.unitName}
                                        </p>
                                    </div>
                                </div>
                                <div className="grid grid-cols-2 gap-3 text-sm mb-3">
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">
                                            #
                                        </p>
                                        <p className="font-medium text-gray-900 dark:text-white">
                                            {item.operationDetailID}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">
                                            Precio
                                        </p>
                                        <p className="font-medium text-gray-900 dark:text-white">
                                            {Number(item.price)}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">
                                            Cantidad
                                        </p>
                                        <p className="font-medium text-gray-900 dark:text-white">
                                            {item.quantity}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">
                                            Subtotal
                                        </p>
                                        <p className="font-semibold text-gray-900 dark:text-white">
                                            S/ {subtotal}
                                        </p>
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1">
                                        Fecha Vencimiento
                                    </label>
                                    <input
                                        type="date"
                                        name="expireDate"
                                        className={inputClass}
                                        value={item.expireDate}
                                        onChange={(e) => {
                                            setOrder({
                                                ...order,
                                                operationItems:
                                                    order.operationItems.map(
                                                        (o) => {
                                                            if (
                                                                o.operationDetailID ==
                                                                item.operationDetailID
                                                            ) {
                                                                o.expireDate =
                                                                    e.target.value;
                                                            }
                                                            return o;
                                                        },
                                                    ),
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    })}
                    {/* Total for Mobile */}
                    <div className="p-4 bg-gray-50 dark:bg-gray-700">
                        <div className="flex justify-between items-center">
                            <span className="font-semibold text-gray-900 dark:text-white">
                                TOTAL
                            </span>
                            <span className="font-bold text-gray-900 dark:text-white text-lg">
                                S/ {totalAmount}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 justify-between items-start sm:items-center">
                <div className="flex flex-wrap gap-3">
                    <Link
                        to="/buys/new_purchase_order"
                        className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
                    >
                        <i className="fas fa-plus"></i>
                        Nuevo
                    </Link>
                    <Link
                        to="/buys/purchase_orders_issued"
                        className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
                    >
                        <i className="fas fa-list"></i>
                        Orden de Compras
                    </Link>
                </div>
                <button
                    type="button"
                    className="inline-flex items-center gap-2 px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors"
                    onClick={handleSave}
                >
                    Guardar cambios
                </button>
            </div>
        </>
    );
}
